import { ready, afterWebflow } from "./core/lifecycle.js";

// Attribute -> lazy import. Only flagged keys are ever import()ed,
// so a site that flags one module never downloads the rest.
const MODULES = {
  "vds-tabs": () => import("./modules/tabs.js"),
  "vds-slider": () => import("./modules/slider.js"),
  "vds-accordion": () => import("./modules/accordion.js"),
  "vds-gallery": () => import("./modules/gallery.js"),
  "vds-filter": () => import("./modules/filter.js"),
  "vds-theme": () => import("./modules/theme.js"),
  "vds-utm": () => import("./modules/utm.js"),
  "vds-video": () => import("./modules/video.js"),
  "vds-text": () => import("./modules/text.js"),
  "vds-header-offset": () => import("./modules/header-offset.js"),
};

// document.currentScript is NULL inside ES modules, so it cannot be used here.
// Find our own <script> by src instead.
function getOwnScript() {
  return (
    document.querySelector('script[src*="@videsigns/kit"]') ||
    document.querySelector('script[src*="/vds.js"]')
  );
}

async function boot() {
  const script = getOwnScript();
  if (!script) {
    console.warn("[vds] could not locate the loader <script> tag");
    return;
  }

  const keys = Object.keys(MODULES).filter((key) => script.hasAttribute(key));
  if (!keys.length) {
    console.info("[vds] no module attributes found on the script tag");
    return;
  }

  await Promise.all(
    keys.map(async (key) => {
      try {
        const mod = await MODULES[key]();
        // Pass the script tag so page-global modules (utm, theme, text)
        // can read script-level config; component modules ignore it.
        await mod.init?.(script);
      } catch (err) {
        console.error(`[vds] failed to load "${key}"`, err);
      }
    })
  );
}

afterWebflow(() => ready(boot));
